import _createClass from "@babel/runtime/helpers/esm/createClass";

var GLBufferAttribute = /*#__PURE__*/function () {
  function GLBufferAttribute(buffer, type, itemSize, elementSize, count) {
    this.buffer = buffer;
    this.type = type;
    this.itemSize = itemSize;
    this.elementSize = elementSize;
    this.count = count;
    this.version = 0;
  }

  var _proto = GLBufferAttribute.prototype;

  _proto.setBuffer = function setBuffer(buffer) {
    this.buffer = buffer;
    return this;
  };

  _proto.setType = function setType(type, elementSize) {
    this.type = type;
    this.elementSize = elementSize;
    return this;
  };

  _proto.setItemSize = function setItemSize(itemSize) {
    this.itemSize = itemSize;
    return this;
  };

  _proto.setCount = function setCount(count) {
    this.count = count;
    return this;
  };

  _createClass(GLBufferAttribute, [{
    key: "needsUpdate",
    set: function set(value) {
      if (value === true) this.version++;
    }
  }]);

  return GLBufferAttribute;
}();

GLBufferAttribute.prototype.isGLBufferAttribute = true;
export { GLBufferAttribute };